import React from 'react';
import { I18nProvider } from '@lingui/react';
import Layout from './shared/navigation/layout/layout';
import useI18n from '../hooks/i18n-hook';

var AppContainer = function AppContainer(props) {
  console.log({
    props: props
  }); // store a current language

  var curLang = props.pageContext.langKey || props.pageContext.language; // set up i18n stuff

  var _useI18n = useI18n(curLang),
      i18n = _useI18n.i18n;

  console.log({
    i18n: i18n
  });
  return /*#__PURE__*/React.createElement(I18nProvider, {
    i18n: i18n
  }, /*#__PURE__*/React.createElement(Layout, props, props.children));
};

export default AppContainer;